import Http from "../http/partner";
import HttpBackoffice from "../http/backoffice";
// eslint-disable-next-line

export const createUser = (params) => Http.post(`/user`, params);
export const getUser = (params) => Http.get(`/schedule/${params}`);
export const forgotPassword = (params) => Http.post(`/user/forgot`, params);
export const resetPassword = (params) => Http.put(`/user/password`, params);
export const refreshToken = (params) => Http.put(`/user/token`, params);
export const loginUser = (params) => Http.post(`/user/login`, params);
export const registerAuditLog = (params) =>
	HttpBackoffice.post(`/audit/save`, params);
